import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseRoutingModule } from './license-routing.module';
import { SharedModule } from '@shared';
import { IndividualLicenseComponent } from './individual-license/individual-license.component';
import { IndividualApplicantComponent } from './individual-applicant/individual-applicant.component';
import { EntityApplicantComponent } from './entity-applicant/entity-applicant.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AddressComponent } from './address/address.component';
import { DocumentComponent } from './document/document.component';
import { NotesComponent } from './notes/notes.component';
import { EntityLicenseComponent } from './entity-license/entity-license.component';
import { ResidentialHistoryModule } from '../residential-history/residential-history.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from './license-date-format';
// import { PaymentsModule } from '../payments/paymentsmodule';

const COMPONENTS = [
  IndividualLicenseComponent,
  IndividualApplicantComponent,
  EntityLicenseComponent,
  EntityApplicantComponent,
  AddressComponent,
  DocumentComponent,
  NotesComponent
]

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    CommonModule,
    SharedModule,
    LicenseRoutingModule,
    ResidentialHistoryModule
    // PaymentsModule
  ],
  providers: [
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER,
  ]
})
export class LicenseModule { }
